import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import { getActionCompletedTime } from '../../utils/actionTiming';

const eventMappings = {};
eventMappings[actions.SAVED_FIRST_VIDEO] = [trackSaveVideoAction];
eventMappings[actions.RECORD_VIDEO_SEND_EMAIL_SUCCESS] = [trackSendEmailAction];

export default function trackRecordVideo(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackSaveVideoAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_VIDEO_SAVED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: getActionCompletedTime(state)()
    });
}

function trackSendEmailAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: getActionCompletedTime(state)()
    });
}